import { useEffect, useState } from 'react'
import { adminService } from 'core/services/adminService'

import c from './assets/sass/advent-stats.module.scss'

export const AdventStats = () => {
    const [stats, setStats] = useState(null)
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        adminService.getAdventDayStats()
            .then(data => setStats(data))
            .catch(console.error)
            .finally(() => setLoading(false))
    }, [])

    if (loading) return <div className={c.loading}>Загрузка...</div>
    if (!stats) return <div className={c.loading}>Ошибка загрузки</div>

    return (
        <div className={c.component}>
            <div className={c.summary}>
                <div className={c.summaryCard}>
                    <span className={c.summaryValue}>{stats.totalActiveUsers}</span>
                    <span className={c.summaryLabel}>Активных юзеров</span>
                </div>
                <div className={c.summaryCard}>
                    <span className={c.summaryValue}>
                        {stats.days.length > 0 ? stats.days[stats.days.length - 1]?.usersReachedDay || 0 : 0}
                    </span>
                    <span className={c.summaryLabel}>Дошли до {stats.totalDays || stats.days.length} дня</span>
                </div>
                <div className={c.summaryCard}>
                    <span className={c.summaryValue}>
                        {stats.currentMonth}/{stats.currentYear}
                    </span>
                    <span className={c.summaryLabel}>Текущий цикл</span>
                </div>
            </div>

            <div className={c.calendar}>
                {stats.days.map(({ day, usersOnDay, usersReachedDay }) => {
                    const intensity = stats.totalActiveUsers > 0
                        ? usersReachedDay / stats.totalActiveUsers
                        : 0

                    return (
                        <div
                            key={day}
                            className={c.day}
                            style={{
                                background: `rgba(255, 136, 0, ${Math.max(0.05, intensity * 0.8)})`,
                                borderColor: intensity > 0.5
                                    ? 'rgba(255, 136, 0, 0.5)'
                                    : 'rgba(255, 255, 255, 0.1)',
                            }}
                        >
                            <span className={c.dayNumber}>{day}</span>
                            <span className={c.dayUsers}>{usersOnDay}</span>
                            <span className={c.dayReached}>≥{usersReachedDay}</span>
                        </div>
                    )
                })}
            </div>

            <div className={c.legend}>
                <span>На дне — кол-во юзеров именно на этом дне</span>
                <span>≥N — кол-во юзеров, которые дошли до этого дня (включая прошедших дальше)</span>
            </div>
        </div>
    )
}
